export function useHeaders() {
  const headers = useState('headers', () => useRequestHeaders())

  return {
    headers,
  }
}
